'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Api = require('../api/Api');

var _Api2 = _interopRequireDefault(_Api);

var _check = require('../lib/check');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class DataStoreNamespace
 *
 * @description
 * Represents a namespace in the dataStore that can be used to be used to interact with
 * the remote API.
 *
 * @property {Array} keys an array of the loaded keys.
 * @property {String} namespace Name of the namespace as on the server.
 */
var DataStoreNamespace = function () {
    function DataStoreNamespace(namespace, keys) {
        var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Api2.default.getApi();

        _classCallCheck(this, DataStoreNamespace);

        if (!(0, _check.isString)(namespace)) {
            throw new Error('DataStoreNamespaces must be called with a string to identify the Namespace');
        }
        this.api = api;
        this.namespace = namespace;
        this.keys = keys || [];
        this.endPoint = 'dataStore';
    }

    /**
     * Get the keys for current namespace.
     *
     * @param forceLoad if true, retrieves and updates internal keys with
     * response from API. Default false
     * @returns {Promise} of the internal list of keys for current namespace.
     */


    _createClass(DataStoreNamespace, [{
        key: 'getKeys',
        value: function getKeys() {
            var _this = this;

            var forceLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!forceLoad) {
                return Promise.resolve(this.keys);
            }

            return this.api.get([this.endPoint, this.namespace].join('/')).then(function (response) {
                if (response && (0, _check.isArray)(response)) {
                    _this.keys = response;
                    return response;
                }
                throw new Error('The requested namespace has no keys or does not exist.');
            });
        }

        /**
         * Retrieves the value of given key in current namespace.
         * @param key to retrieve
         * @returns {Promise} with the value of the key.
         */

    }, {
        key: 'get',
        value: function get(key) {
            return this.api.get([this.endPoint, this.namespace, key].join('/'));
        }

        /**
         * Retrieves metaData of given key in current namespace.
         * @param key to retrieve metaData for
         */

    }, {
        key: 'getMetaData',
        value: function getMetaData(key) {
            return this.api.get([this.endPoint, this.namespace, key, 'metaData'].join('/'));
        }

        /**
         * Sets the value of given key to given value.
         * This will also create a new namespace on the API-end if it does not exist.
         * If the key exists {@link update} will be called.
         * @param key in namespace to update.
         * @param value to be set
         * @param overrideUpdate - If true a post-request is sent even if key exists.
         * @returns {Promise}
         */

    }, {
        key: 'set',
        value: function set(key, value) {
            var _this2 = this;

            var overrideUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (!overrideUpdate && this.keys.includes(key)) {
                return this.update(key, value);
            }
            return this.api.post([this.endPoint, this.namespace, key].join('/'), value).then(function () {
                _this2.keys = [].concat(_toConsumableArray(_this2.keys), [key]);
            });
        }

        /**
         * Deletes given key from the API.
         * @param key to delete.
         */

    }, {
        key: 'delete',
        value: function _delete(key) {
            var ind = this.keys.indexOf(key);
            if (ind > -1) {
                this.keys = [].concat(_toConsumableArray(this.keys.slice(0, ind)), _toConsumableArray(this.keys.slice(ind + 1)));
            }
            return this.api.delete([this.endPoint, this.namespace, key].join('/'));
        }

        /**
         * Updates a key with given value.
         * @param key to update
         * @param value to update to
         * @returns {Promise} of return value from API-call.
         */

    }, {
        key: 'update',
        value: function update(key, value) {
            return this.api.update([this.endPoint, this.namespace, key].join('/'), value);
        }
    }]);

    return DataStoreNamespace;
}();

exports.default = DataStoreNamespace;
//# sourceMappingURL=DataStoreNamespace.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/datastore/DataStoreNamespace.js
// module id = 482
// module chunks = 0